var map = {
	"./driver_experience.gif": 3735,
	"./driver_experience.webp": 8029,
	"./mobile_partner_hero_banner.jpeg": 9058,
	"./mobile_partner_hero_banner.webp": 3198,
	"./owner_banner.jpg": 8938,
	"./partner_benefits.png": 5798,
	"./partner_features.png": 2203,
	"./partner_hero_banner_dubai.png": 5621,
	"./partner_hero_banner_dubai.webp": 6419,
	"./partner_testimonial.jpg": 7978,
	"./website_partner_page_bangla.png": 5658,
	"./website_partner_page_bangla.webp": 8845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4199;